/** время жизни кода (сек) */
const START_TIME_CODE_LEAVE = 30;
/** интервал между отправкой подтверждения кода  */
const ATTEMPT_TIME_INTERVAL = 15;
let leaveTimerId;
let attemptTimerId;

/**
 * otpStore module
 */
export const OtpStoreModule = {
  namespaced: true,
  state: () => {
    return {
      isShowed: false,
      /** время между отправкой подтверждения кода */
      attemptTime: 0,
      /** время жизни кода (сек) */
      currentTime: 0,
      isSendSmsPending: false,
      isSendSmsCodePending: false,
      verifiedPhone: '',
    };
  },
  getters: {
    isSendSmsAvailable(state) {
      return state.currentTime === 0;
    },
    isSendSmsCodeAvailable(state) {
      return state.attemptTime === 0;
    },
  },
  mutations: {
    SET_IS_SHOWED(state, val) {
      state.isShowed = val;
    },
    SET_CURRENT_TIME(state, val) {
      state.currentTime = val;
    },
    SET_ATTEMPT_TIME(state, val) {
      state.attemptTime = val;
    },
    SET_IS_SEND_SMS_PENDING(state, val) {
      state.isSendSmsPending = val;
    },
    SET_IS_SEND_SMS_CODE_PENDING(state, val) {
      state.isSendSmsCodePending = val;
    },
    SET_VERIFIED_PHONE(state, val) {
      state.verifiedPhone = val;
    },
  },
  actions: {
    startTimer({ state, commit }) {
      if (state.currentTime > 0) return;

      commit('SET_CURRENT_TIME', START_TIME_CODE_LEAVE);
      leaveTimerId = setInterval(() => {
        if (state.currentTime > 0) {
          commit('SET_CURRENT_TIME', state.currentTime - 1);
          if (state.currentTime === 0) {
            clearInterval(leaveTimerId);
          }
        }
      }, 1000);
    },
    startAttemptTimer({ state, commit }) {
      if (state.attemptTime > 0) return;

      commit('SET_ATTEMPT_TIME', ATTEMPT_TIME_INTERVAL);
      attemptTimerId = setInterval(() => {
        if (state.attemptTime > 0) {
          commit('SET_ATTEMPT_TIME', state.attemptTime - 1);

          if (state.attemptTime === 0) {
            clearInterval(attemptTimerId);
          }
        }
      }, 1000);
    },
    open({ commit }) {
      commit('SET_IS_SHOWED', true);
    },
    close({ commit }) {
      commit('SET_IS_SHOWED', false);
    },
    checkVerify({ state }, phone) {
      return phone === state.verifiedPhone;
    },
  }
};
